(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const stickyHeader = document.querySelector(".header-wrapper");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const megaMenuLinks = document.querySelectorAll(".header-mega-menu__have-submenu__list .first-link");
		const megaMenuItem = document.querySelectorAll(".header__megamenu-item");
		const headerSimpleMenuLinks = document.querySelectorAll('.header__submenu--simple .header__submenu-li');

		headerSimpleMenuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				headerSimpleMenuLinks.forEach((el) => {
					if (el === e.target) {
						el.querySelector('.header__submenu').classList.add('show-submenu');
						el.querySelector('.header__submenu').classList.remove('remove-submenu');
					} else {
						el.querySelector('.header__submenu').classList.remove('show-submenu');
						el.querySelector('.header__submenu').classList.add('remove-submenu');
					}

				})
			})
		})

		let disableHover = false;
		let activeItem = null;

		megaMenuItem.forEach((item) => {

			item.addEventListener("mouseenter", () => {
				if (disableHover) return;

				stickyHeader.classList.add("mega-menu-open");
				document.querySelector('.header-mega-menu__overlay')?.classList.add('active');
				document.querySelectorAll(".header__account details").forEach(item => item.removeAttribute('open'));
				document.querySelectorAll(".disclosure__button").forEach(button => button.setAttribute("aria-expanded", "false"));
				document.querySelectorAll(".disclosure__list").forEach(list => list.setAttribute("hidden", ""));
				document.querySelectorAll(".header__submenu").forEach(item => item.style.zIndex = -2);
			})

			item.parentElement.addEventListener("mouseleave", () => {
				if (disableHover) return;
				stickyHeader.classList.remove("mega-menu-open");
				document.querySelector('.header-mega-menu__overlay')?.classList.remove('active');
				document.querySelectorAll(".header__submenu").forEach(item => item.style.zIndex = 'unset');
			})

			 item.addEventListener('click', (e) => {
				const href = item.getAttribute('href');
				if (href && href === '#') {
					disableHover = true;
					activeItem = item;
					e.preventDefault(); 
				}
			});
			
		})

		
		document.addEventListener('click', (e) => {
			const clickedItem = activeItem?.contains(e.target)
			const href = activeItem?.getAttribute('href')

			if (href && href === '#') {
				if (clickedItem) return
				disableHover = false
				stickyHeader.classList.remove('mega-menu-open')
				document
					.querySelector('.header-mega-menu__overlay')
					?.classList.remove('active')
				document
					.querySelectorAll('.header__submenu')
					.forEach((item) => (item.style.zIndex = 'unset'))
				activeItem = null
			}
		})

		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (event) => {
				megaMenuLinks[0].classList.add('remove-sub-links');
				megaMenuLinks.forEach((item) => {
					item.classList.remove('show-sub-links');
				})
				event.target.classList.add('show-sub-links');
			})
		})
		
		if (headerDetails) {
			headerDetails.addEventListener("toggle", function () {
				const colorScheme =
					this.querySelector("#menu-drawer").dataset.colorScheme;
				header.classList.toggle(colorScheme);
			});
		}
		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		/* Scroll class management handled by StickyHeader onScroll() in header.liquid. */

		/* ── Mobile subnav drawer ── */
		/* Move drawers to <body> so position:fixed escapes
		   backdrop-filter containing blocks (same pattern as burger-drawer) */
		document.querySelectorAll("[data-subnav-drawer]").forEach(function (drawer) {
			if (drawer.parentElement !== document.body) {
				document.body.appendChild(drawer);
			}
		});

		const subnavTriggers = document.querySelectorAll("[data-subnav-trigger]");
		const subnavDrawers = document.querySelectorAll("[data-subnav-drawer]");

		subnavTriggers.forEach(function (trigger) {
			trigger.addEventListener("click", function () {
				var handle = trigger.getAttribute("data-subnav-trigger");
				var drawer = document.querySelector('[data-subnav-drawer="' + handle + '"]');
				if (drawer) {
					drawer.setAttribute("data-open", "true");
					trigger.setAttribute("aria-expanded", "true");
					body.classList.add("overflow-hidden");

					/* Update Swiper after slide-in transition so it can measure widths */
					var panel = drawer.querySelector(".header__subnav-drawer-panel");
					if (panel) {
						var onTransitionEnd = function () {
							panel.removeEventListener("transitionend", onTransitionEnd);
							drawer.querySelectorAll("carousel-swiper").forEach(function (el) {
								if (el.swiper) el.swiper.update();
							});
						};
						panel.addEventListener("transitionend", onTransitionEnd);
					}
				}
			});
		});

		subnavDrawers.forEach(function (drawer) {
			var closeBtn = drawer.querySelector(".header__subnav-drawer-close");
			var overlay = drawer.querySelector(".header__subnav-drawer-overlay");

			var closeDrawer = function () {
				var handle = drawer.getAttribute("data-subnav-drawer");
				var trigger = document.querySelector('[data-subnav-trigger="' + handle + '"]');
				drawer.removeAttribute("data-open");
				if (trigger) trigger.setAttribute("aria-expanded", "false");
				var anyOpen = document.querySelector('[data-subnav-drawer][data-open], .burger-drawer.active');
				if (!anyOpen) body.classList.remove("overflow-hidden");
			};

			if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
			if (overlay) overlay.addEventListener("click", closeDrawer);

			/* Accordion toggles — same jQuery slideDown/slideUp as burger drawer */
			$(drawer).find("[data-subnav-accordion]").on("click", function () {
				var $btn = $(this);
				var $row = $btn.closest(".header__subnav-drawer-link-row");
				var $content = $btn.siblings(".header__subnav-accordion-content");

				if ($btn.attr("aria-expanded") !== "true") {
					/* Close same-level siblings */
					$row.siblings().find("[data-subnav-accordion][aria-expanded='true']").attr("aria-expanded", "false");
					$row.siblings().find(".header__subnav-accordion-content").stop().slideUp(300);

					$btn.attr("aria-expanded", "true");
					$content.stop().slideDown(300);
				} else {
					$btn.attr("aria-expanded", "false");
					$content.stop().slideUp(300);
				}
			});
		});
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
